<template>
  <v-container class="h-100 pa-0 ma-0" fluid>
    <v-form ref="form" lazy-validation class="h-100 pa-0 ma-0">
      <v-row class="pa-0 ma-0 h-100">
        <v-col v-if="smAndUp" sm="6" class="pa-0 ma-0 h-100">
          <div
            class="h-100 w-100"
            style="
              background-image: url(&quot;/assets/imgs/gym-left.jpeg&quot;);
              background-size: cover;
              background-position: center;
              display: flex;
              align-items: center;
              justify-content: center;
            "
          >
            <v-img src="/assets/logo.png" max-width="350" contain></v-img>
          </div>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="12" sm="6" lg="4" class="pa-0 ma-0 h-100"
          ><v-card class="pa-0 ma-0 pt-5 h-100 px-sm-5" variant="text">
            <v-card-title
              class="text-h4 text-center text-sm-left text-primary mt-sm-5"
              >{{ resources.WelcomeMessage }}</v-card-title
            >
            <v-card-subtitle class="text-subtitle-2 text-center text-sm-left">{{
              resources.InsertCredentials
            }}</v-card-subtitle>
            <v-card-text class="h-50 mt-5">
              <v-container class="pa-0 ma-0 mt-5 h-100">
                <v-row class="pa-0 ma-0 mt-5 h-50">
                  <v-col cols="12" class="mt-5">
                    <v-text-field
                      v-model="username"
                      :rules="[globalStore.rules.required]"
                      density="compact"
                      :label="resources.User"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="password"
                      :rules="[globalStore.rules.required]"
                      :label="resources.Password"
                      :type="show ? 'text' : 'password'"
                      density="compact"
                      :append-inner-icon="
                        show ? 'mdi-eye-off-outline' : 'mdi-eye-outline'
                      "
                      @click:append-inner="toggleShow"
                    />
                  </v-col>
                  <v-col cols="12" class="pa-0 ma-0">
                    <v-btn
                      density="compact"
                      variant="text"
                      class="w-100"
                      @click="registerForm"
                      >{{ resources.DontHaveAccount }}</v-btn
                    >
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions class="d-flex flex-column">
              <v-row class="pa-0 ma-0 w-100">
                <v-col cols="12">
                  <v-tooltip :text="resources.Login">
                    <template v-slot:activator="{ props }">
                      <v-btn
                        color="primary"
                        variant="elevated"
                        block
                        :loading="globalStore.loading"
                        @click="loginUser"
                        >{{ resources.Login }}</v-btn
                      >
                    </template>
                  </v-tooltip>
                </v-col>
              </v-row>
              <v-row class="pa-0 ma-0 mt-5">
                <v-col cols="12" class="pa-0 ma-0">
                  <v-btn
                    density="compact"
                    variant="text"
                    class="w-100"
                    style="color: rgb(var(--v-theme-primary))"
                    @click="resetPassword"
                    >{{ resources.ForgotPassword }}</v-btn
                  >
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card></v-col
        >
        <v-spacer></v-spacer>
      </v-row>
    </v-form>
  </v-container>

  <v-dialog v-model="showPopup" persistent max-width="800px" scrollable>
    <v-card
      class="crud-card border-lg"
      style="border-color: rgb(var(--v-theme-primary)) !important"
    >
      <v-card-title class="text-h6 bg-primary text-background">{{
        resources.SelectBranch
      }}</v-card-title>

      <v-card-text>
        <v-row class="mb-0">
          <v-col cols="12">
            <v-select
              :label="resources.Branch"
              color="primary"
              v-model="idBranch"
              density="comfortable"
              :hint="resources.BranchHelp"
              persistent-hint
              :items="branches"
              :rules="[globalStore.rules.required]"
            ></v-select>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-tooltip :text="resources.Login">
          <template v-slot:activator="{ props }">
            <v-btn
              v-bind="props"
              color="primary"
              variant="outlined"
              class="mr-2 mb-2"
              :loading="globalStore.loading"
              :readonly="globalStore.loading"
              @click="loginUser"
              prepend-icon="mdi-login"
              >{{ resources.Login }}</v-btn
            >
          </template>
        </v-tooltip>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="showPopupPassword" persistent max-width="800px" scrollable>
    <v-card
      class="crud-card border-lg"
      style="border-color: rgb(var(--v-theme-primary)) !important"
    >
      <v-card-title class="text-h6 bg-primary text-background">{{
        resources.PasswordRecoveryTitle
      }}</v-card-title>

      <v-card-text>
        <v-form ref="formPassword" lazy-validation class="ma-0 pa-0">
          <v-row class="mb-0">
            <v-col cols="12">
              <v-text-field
                :label="resources.Email"
                color="primary"
                v-model="email"
                density="comfortable"
                :rules="[globalStore.rules.required, globalStore.rules.email]"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions class="justify-end">
        <v-tooltip :text="resources.Close" location="bottom">
          <template v-slot:activator="{ props }">
            <v-btn
              v-bind="props"
              color="error"
              prepend-icon="mdi-close"
              variant="outlined"
              class="ml-2 mb-2"
              :loading="loadingSave"
              :readonly="loadingSave"
              @click="showPopupPassword = false"
            >
              {{ resources.Cancel }}</v-btn
            >
          </template>
        </v-tooltip>
        <v-spacer></v-spacer>
        <v-tooltip :text="resources.Save" location="bottom">
          <template v-slot:activator="{ props }">
            <v-btn
              v-bind="props"
              color="primary"
              variant="outlined"
              class="mr-2 mb-2"
              :loading="loadingSave"
              :readonly="loadingSave"
              prepend-icon="mdi-email-arrow-left-outline"
              @click="sendRecoveryMail"
            >
              {{ resources.Confirm }}</v-btn
            >
          </template>
        </v-tooltip>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { storeToRefs } from "pinia";
import { ref } from "vue";
import { useDisplay } from "vuetify";

const { smAndUp } = useDisplay();

const globalStore = window.useGlobalStore();
const form = ref(null);
const formPassword = ref(null);
const formInvalid = ref(false);

const { resources } = storeToRefs(globalStore);

const username = ref(null);
const password = ref(null);
const idBranch = ref(null);
const branches = ref([]);
const showPopup = ref(false);
const showPopupPassword = ref(false);
const email = ref(null);

const show = ref(false);
const toggleShow = () => {
  show.value = !show.value;
};

const resetPassword = () => {
  email.value = null;
  showPopupPassword.value = true;
};

const registerForm = () => {
  window.location.href = "/Home/Register";
};

const sendRecoveryMail = async () => {
  globalStore.setLoading(true);
  const isValid = await formPassword.value.validate();
  if (!isValid.valid) {
    globalStore.setLoading(false);
    return globalStore.showError(resources.value.EmailIsRequired);
  }
  try {
    window.axios
      .post("/Home/RecoverPassword", email.value)
      .then((res) => {
        const jsonData = res.data;
        if (jsonData.result == 0) {
          globalStore.showSuccess(jsonData.content);
        } else {
          globalStore.showError(jsonData.content);
        }
      })
      .catch(globalStore.errorHandler)
      .finally(() => {
        globalStore.setLoading(false);
      });
  } catch (error) {
    globalStore.setLoading(false);
    console.error(error);
    globalStore.showError(resources.value.ErrorGeneric);
  }
};

const loginUser = async () => {
  globalStore.setLoading(true);
  const isValid = await form.value.validate();
  formInvalid.value = !isValid.valid;
  if (formInvalid.value) {
    globalStore.setLoading(false);
    return globalStore.showError(resources.value.FormContainsErrors);
  }

  try {
    window.axios
      .post("/Home/Login", {
        username: username.value,
        password: password.value,
        idBranch: idBranch.value,
      })
      .then((res) => {
        const jsonData = res.data;
        if (jsonData.result == 0) {
          showPopup.value = true;
          branches.value = Array.from(jsonData.content);
        } else if (jsonData.result == 2) {
          window.location.href = jsonData.url;
        } else {
          globalStore.showError(jsonData.error);
        }
      })
      .catch(globalStore.errorHandler)
      .finally(() => {
        globalStore.setLoading(false);
      });
  } catch (error) {
    globalStore.setLoading(false);
    console.error(error);
    globalStore.showError(resources.value.ErrorGeneric);
  }
};
</script>
